import React from 'react';
import styled from 'styled-components';

const MapFigure = styled.figure`
  display: block;

  img {
    width: 100%;
    height: auto;
  }
`;

const MapAnchor = styled.a`
  color: ${({theme}) => theme.LinkColor};
  display: block;
  margin: 20px;
  &:hover{
    text-decoration: underline;
  }
`

const StaticMap = styled(({ coordinates = undefined, location = undefined, lang, ...rest}) => {
  let place = location;
  if(coordinates){
    const {lat = undefined, lon = undefined} = coordinates
    place = `${lat},${lon}`;
  }
  if (!place || place === 'undefined,undefined'){
    return null
  }
  return (
    <MapFigure {...rest}>
      <img
        src={`https://maps.googleapis.com/maps/api/staticmap?size=340x207&maptype=roadmap&key=AIzaSyCPmrjBFZz2tspwnpKyT7VvLCER2GQtuK4&markers=${place}&language=${lang}&scale=2&zoom=12`}
        alt=""
      />
    </MapFigure>
  );
})``;

StaticMap.displayName = 'StaticMap'

const MapLink = styled(({ coordinates = undefined, location = undefined, lang, children, ...rest}) => {
  let place = location;
  if(coordinates){
    const {lat = undefined, lon = undefined} = coordinates
    place = `${lat},${lon}`;
  }
  if (!place || place === 'undefined,undefined'){
    return null
  }
  return (
    <MapAnchor
      className="map--link"
      href={`https://maps.google.com/?q=${place}&maptype=roadmap&language=${lang}`}
      target="_blank">
      {children}
    </MapAnchor>
  );
})`background-color: green;`

export {
  StaticMap,
  MapLink,
}



// WEBPACK FOOTER //
// ./src/modules/common/components/ui/StaticMap.js